import { createUseStyles } from 'react-jss'
import { commonStyles } from '../common.styles'
import {
  voucherButton,
  voucherButtonGroup,
  voucherContainer
} from '../voucher-common.styles'

export const voucherFormStyles = theme => ({
  ...commonStyles(theme),
  voucherContainer: voucherContainer(theme),

  inputError: {
    borderColor: theme.error,

    '&:focus': {
      borderColor: theme.error
    }
  },

  title: {
    fontSize: 30,
    fontWeight: 350,
    lineHeight: '36px',
    textAlign: 'center',
    marginBottom: 30,
    [theme.media.smallMobile]: {
      fontSize: 26
    },
    [theme.media.mobile]: {
      fontSize: 26
    }
  },

  fieldError: {
    visibility: 'hidden',
    display: 'inline-block',
    color: theme.error,
    fontSize: 10,
    margin: [2, 0, 0]
  },

  visible: {
    visibility: 'visible'
  },

  buttonContainer: voucherButtonGroup(theme),

  button: voucherButton(theme)
})

export const useStyles = createUseStyles(voucherFormStyles)
